export const menu = {
  menu_title: 'Resonance',
  menu_logOut: 'Log Out',
  menu_language_button_text: 'Change',
  menu_languages_modal_title: 'Choose your language',
  menu_questionnaires_modal_title: 'Choose a questionnaire'
};
